import { render, staticRenderFns } from "./BuyThisDesignModal.vue?vue&type=template&id=f7ed2b1a&"
import script from "./BuyThisDesignModal.vue?vue&type=script&lang=js&"
export * from "./BuyThisDesignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports